import useTranslation from "next-translate/useTranslation";
import NumbersGrid, { NumbersTileProps } from "../common/NumbersGrid";
import { Box } from "rebass/styled-components";

function AboutNumbersGrid({ variant = "default" }: { variant?: string }) {
  const { t } = useTranslation("about");

  const itemsNumbers: NumbersTileProps[] = [...Array(4)].map((_, i) => {
    return {
      title: t(`numbersTileTitle${i + 1}`),
      desc: t(`numbersTileDesc${i + 1}`)
    };
  });

  return (
    <NumbersGrid
      title={t("numbersTitle")}
      items={itemsNumbers}
      numCols={2}
      variant={variant}
    />
  );
}

export default AboutNumbersGrid;
